import React, { useEffect, useRef, useState } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { File, Folder } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ArrowIcon from "../../Icons/ArrowIcon";
import GridIcon from "../../Icons/GridIcon";
import ListIcon from "../../Icons/ListIcon";
import SearchIcon from "../../Icons/SearchIcon";
import { classNames } from "../../utils/classNames";
import CreateFolder from "../Dashboard/CreateFolder";
import RenameFolder from "../Dashboard/RenameFolder";
import AddFolder from "../Reusable/AddFolder";
import FileOptions from "../Reusable/FileOptions";
import CustomFileViewer from "../Reusable/FileViewer";
import Modal from "../Reusable/Modal";
import Options from "../Reusable/OptionsPopOver";
import Search from "../Search";
import DropFile from "./DropFile";
import RenameFile from "./RenameFile";
import TableView from "./TableView";
import Preview from "../Reusable/Preview";
import CustomPreview from "../Reusable/CustomPreview";

const Folders = (props: any) => {
  const {
    data,
    fileList,
    folderList,
    handleDeleteFile,
    handleDeleteFolder,
    isdeleteLoading,
    isDeleting,
  } = props;
  const [qrImage, setQrImage] = useState<string | null>(null);
  const [openQrUploadPopup, setOpenQrUploadPopup] = useState(false);
  const [openCreateFolderPopup, setOpenCreateFolderPopup] = useState(false);
  const [openRenameFolderPopup, setOpenRenameFolderPopup] = useState(false);
  const [openRenameFilePopup, setOpenRenameFilePopup] = useState(false);
  const [openSearchPopup, setOpenSearchPopup] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const limit = parseInt(searchParams.get("limit") || "10", 10);
  const observerRef = useRef<HTMLDivElement | null>(null);

  const [view, setView] = useState<"list" | "grid">(() => {
    const saved = localStorage.getItem("dashboardView");
    return saved === "grid" || saved === "list" ? saved : "list";
  });

  useEffect(() => {
    setSearchParams({ limit: "12" });
  }, []);
  useEffect(() => {
    setSearchParams({ limit: "12" });
  }, [view]);

  useEffect(() => {
    localStorage.setItem("dashboardView", view);
  }, [view]);

  const [selected, setSelected] = useState({
    id: "",
    title: "",
  });

  const getBreadcrumbs = (node: any): { title: string; id: string }[] => {
    const crumbs: { title: string; id: string }[] = [];
    let current = node?.parent;

    while (current) {
      crumbs.unshift({ title: current.title, id: current.id });
      current = current.parent;
    }

    return crumbs;
  };
  const breadcrumbs = getBreadcrumbs(data);

  const foldersWithType =
    folderList?.map((f: any) => ({
      ...f,
      _type: "folder",
    })) || [];

  const filesWithType =
    fileList?.map((f: any) => ({
      ...f,
      _type: "file",
    })) || [];

  const combined = [...foldersWithType, ...filesWithType];

  const visible = combined.slice(0, limit);

  const visibleFolders = visible.filter((i) => i._type === "folder");
  const visibleFiles = visible.filter((i) => i._type === "file");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && combined.length > limit) {
          setSearchParams({ limit: (limit + 10).toString() });
        }
      },
      { threshold: 1 }
    );

    const current = observerRef.current;
    if (current) observer.observe(current);

    return () => {
      if (current) observer.unobserve(current);
    };
  }, [limit, combined.length, setSearchParams]);

  return (
    <>
      <div className={tw``}>
        <div
          className={tw`text-sm text-gray-500 flex flex-wrap gap-x-1 my-2 items-center sticky top-0 bg-white z-10 py-2 px-1 rounded-lg shadow`}
        >
          <span
            onClick={() => navigate(`/file-manager`)}
            className={tw`cursor-pointer text-lg rounded-xl hover:bg-gray-200 hover:text-gray-700 p-2 flex items-center`}
          >
            My Drive
          </span>
          <span
            className={tw`text-gray-400 mx-1 text-lg font-semibold select-none`}
          >
            <ArrowIcon />
          </span>

          {breadcrumbs.map((crumb, index) =>
            crumb?.title ? (
              <React.Fragment key={crumb?.id || crumb?.title}>
                <span
                  onClick={() => navigate(`/file-manager/folder/${crumb.id}`)}
                  className={tw`cursor-pointer text-lg hover:bg-gray-200 hover:text-gray-700 p-2 rounded-xl flex items-center`}
                >
                  {crumb?.title}
                </span>
                <span
                  className={tw`text-gray-400 mx-1 text-lg font-semibold select-none`}
                >
                  <ArrowIcon />
                </span>
              </React.Fragment>
            ) : null
          )}

          <span className={tw`text-gray-700 text-lg p-2 font-semibold`}>
            {data?.title}
          </span>
        </div>

        <div className={tw`flex justify-between items-center`}>
          <AddFolder
            id={data?.id}
            folderName={data?.title}
            setQrImage={setQrImage}
            qrImage={qrImage}
            setOpenQrUploadPopup={setOpenQrUploadPopup}
            setOpenCreateFolderPopup={setOpenCreateFolderPopup}
          />
          <div className={tw`flex gap-x-4 items-center`}>
            <div
              className={tw`grid grid-cols-2   border-1 border-gray-600 rounded-xl overflow-hidden`}
            >
              <button
                onClick={() => setView("list")}
                type="button"
                className={classNames(
                  view === "list" ? tw`bg-gray-300` : tw``,
                  tw`px-3 py-1 focus:outline-none`
                )}
              >
                <ListIcon />
              </button>
              <button
                onClick={() => setView("grid")}
                type="button"
                className={classNames(
                  view === "grid" ? tw`bg-gray-300 ` : tw``,
                  tw`px-3 py-1 focus:outline-none`
                )}
              >
                <GridIcon />
              </button>
            </div>
            <button
              type="button"
              onClick={() => setOpenSearchPopup(true)}
              className={tw`focus:outline-none`}
            >
              <SearchIcon />
            </button>
          </div>
        </div>

        {(Array.isArray(folderList) && folderList?.length > 0) ||
        (Array.isArray(fileList) && fileList?.length > 0) ? (
          view === "grid" ? (
            <>
              <div className={tw`my-2`}>
                {visibleFolders.length > 0 && (
                  <>
                    <h2 className={tw`text-lg font-semibold`}>Folders</h2>
                    <div className={tw`grid grid-cols-4 gap-4 mt-2`}>
                      {visibleFolders.map((folder: any) => (
                        <div
                          key={folder.id}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`folder/${folder.id}`);
                          }}
                          className={tw`bg-[#DEDEDEC2] cursor-pointer rounded p-4 flex items-center justify-between shadow hover:bg-gray-300`}
                        >
                          <div className={tw`flex items-center gap-3`}>
                            <Folder />
                            <p className={tw`truncate max-w-[120px]`}>
                              {folder.title}
                            </p>
                          </div>

                          <Options
                            setSelected={setSelected}
                            folder={folder}
                            setOpenRenameFolderPopup={setOpenRenameFolderPopup}
                            handleDelete={handleDeleteFolder}
                            isdeleteLoading={isDeleting}
                          />
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>

              {visibleFiles.length > 0 && (
                <>
                  <h2 className={tw`text-lg py-2 font-semibold`}>Files</h2>
                  <div className={tw`grid grid-cols-4 gap-4 mt-2`}>
                    {visibleFiles.map((item: any) => {
                      const title = item?.title || "";
                      const filePath = item?.file;
                      const extensionMatch = title.match(/\.(\w+)$/);
                      const fileType = extensionMatch
                        ? extensionMatch[1].toLowerCase()
                        : "";

                      return (
                        <div
                          key={item.id}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedFile({
                              url: filePath,
                              title,
                              type: fileType,
                            });
                          }}
                          className={tw`bg-[#DEDEDEC2] cursor-pointer hover:bg-gray-300 rounded-lg shadow-md`}
                        >
                          <div className={tw`p-2 flex justify-between`}>
                            <p className={tw`text-sm truncate`}>{title}</p>

                            <FileOptions
                              setSelected={setSelected}
                              file={item}
                              setOpenRenameFolderPopup={setOpenRenameFilePopup}
                              handleDelete={handleDeleteFile}
                              isdeleteLoading={isdeleteLoading}
                            />
                          </div>

                          {[
                            "pdf",
                            "docx",
                            "xlsx",
                            "png",
                            "jpg",
                            "mp4",
                            "jpeg",
                          ].includes(fileType) ? (
                            <CustomFileViewer
                              filePath={filePath}
                              fileType={fileType}
                            />
                          ) : (
                            <div
                              className={tw`h-32 flex items-center justify-center text-gray-500`}
                            >
                              <span>
                                <File /> {fileType.toUpperCase()}
                              </span>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </>
          ) : (
            <TableView
              setSelected={setSelected}
              setOpenRenameFolderPopup={setOpenRenameFolderPopup}
              handleDeleteFolder={handleDeleteFolder}
              isDeleting={isDeleting}
              handleDeleteFile={handleDeleteFile}
              setOpenRenameFilePopup={setOpenRenameFilePopup}
              isdeleteLoading={isdeleteLoading}
              folderList={folderList}
              fileList={fileList}
            />
          )
        ) : (
          // <FileUpload object_id={data?.id} />
          <DropFile
            data={data}
            setQrImage={setQrImage}
            setOpenQrUploadPopup={setOpenQrUploadPopup}
          />
        )}
        <Preview
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
        />
      </div>
      <div ref={observerRef} className={tw`h-10`} />
      <Modal
        isOpen={openCreateFolderPopup}
        title={"New Folder"}
        setIsOpen={setOpenCreateFolderPopup}
      >
        <CreateFolder
          id={data?.id}
          setOpenCreateFolderPopup={setOpenCreateFolderPopup}
        />
      </Modal>
      <Modal
        isOpen={openRenameFilePopup}
        title={"Rename"}
        setIsOpen={setOpenRenameFilePopup}
      >
        <RenameFile
          selected={selected}
          setOpenRenameFolderPopup={setOpenRenameFilePopup}
        />
      </Modal>
      <Modal
        isOpen={openRenameFolderPopup}
        title={"Rename"}
        setIsOpen={setOpenRenameFolderPopup}
      >
        <RenameFolder
          selected={selected}
          setOpenRenameFolderPopup={setOpenRenameFolderPopup}
        />
      </Modal>

      <Modal
        title={"Search"}
        isOpen={openSearchPopup}
        setIsOpen={setOpenSearchPopup}
      >
        <Search setOpenSearchPopup={setOpenSearchPopup} />
      </Modal>
      <Modal
        title={"Scan QR to upload"}
        isOpen={openQrUploadPopup}
        setIsOpen={setOpenQrUploadPopup}
      >
        <div className={tw`mt-4 w-96`}>
          <img
            src={qrImage}
            alt="Generated QR Code"
            className={tw`w-full h-64 object-contain border p-2 rounded`}
          />
        </div>
      </Modal>
    </>
  );
};

export default Folders;

